/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit } from './IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit';
import {
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitFromJSON,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitFromJSONTyped,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitToJSON,
} from './IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit';

/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom
 */
export interface IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom {
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom
     */
    name?: string;
    /**
     * 
     * @type {IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit}
     * @memberof IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom
     */
    bed_unit?: IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit;
}

/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomFromJSON(json: any): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom {
    return IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'bed_unit': !exists(json, 'bed_unit') ? undefined : IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitFromJSON(json['bed_unit']),
    };
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomToJSON(value?: IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'bed_unit': IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitToJSON(value.bed_unit),
    };
}

